<template>
    <div class="c-switch-modal" :class="{ 'is-disabled': addressIsSubmitting }">
        <div class="c-switch-modal__content">
            <div class="c-switch-header">
                <div class="c-switch-header__title">
                    {{ newAddressTitle }}
                </div>
            </div>

            <div class="c-switch-content">
                <div class="c-switch-content__section c-switch-content__section--addresses">
                    <Autocomplete v-if="!newAddressChecked" :addingAddress="true" />

                    <div v-else class="c-switch-form">
                        <div class="l-row has-xs-gutter cxs-is-column cxs-without-gutter">
                            <div class="l-col">
                                <TextInput
                                    ref="inputName"
                                    :name="`name`"
                                    :label="
                                        shopType === 'b2b'
                                            ? $t('Switch.Form.Name.label')
                                            : $t('Switch.Form.Company.label')
                                    "
                                    :placeholder="
                                        shopType === 'b2b'
                                            ? $t('Switch.Form.Name.placeholder')
                                            : $t('Switch.Form.Company.placeholder')
                                    "
                                    v-model="newAddressData.name"
                                />
                            </div>

                            <div class="l-col">
                                <TextInput
                                    ref="inputCompany"
                                    :name="`company`"
                                    :label="
                                        shopType === 'b2b'
                                            ? $t('Switch.Form.Company.label')
                                            : $t('Switch.Form.Name.label')
                                    "
                                    :placeholder="
                                        shopType === 'b2b'
                                            ? $t('Switch.Form.Company.placeholder')
                                            : $t('Switch.Form.Name.placeholder')
                                    "
                                    v-model="newAddressData.company"
                                />
                            </div>
                        </div>

                        <div class="l-row has-xs-gutter">
                            <div class="l-col cxs-has-size-12 xs-has-size-6">
                                <TextInput
                                    ref="inputAddress"
                                    :disabled="!isInternationalAddress"
                                    :name="`address`"
                                    :label="$t('Switch.Form.Address.label')"
                                    :placeholder="$t('Switch.Form.Address.placeholder')"
                                    v-model="newAddressData.address"
                                />
                            </div>

                            <div class="l-col">
                                <TextInput
                                    ref="inputCity"
                                    :disabled="true"
                                    :name="`city`"
                                    :label="$t('Switch.Form.City.label')"
                                    :placeholder="$t('Switch.Form.City.placeholder')"
                                    v-model="newAddressData.city"
                                />
                            </div>

                            <div class="l-col cxs-has-size-6 xs-has-size-3">
                                <TextInput
                                    ref="inputPostCode"
                                    :disabled="true"
                                    :name="`post_code`"
                                    :label="$t('Switch.Form.PostCode.label')"
                                    :placeholder="$t('Switch.Form.PostCode.placeholder')"
                                    v-model="newAddressData.postCode"
                                />
                            </div>
                        </div>

                        <div class="l-row has-xs-gutter cxs-is-column cxs-without-gutter">
                            <div class="l-col">
                                <div class="c-form__item c-form__item--select is-required">
                                    <label class="c-form__label" for="country_id">
                                        {{ $t("Switch.Form.Country.label") }}:
                                    </label>

                                    <select
                                        v-model="newAddressData.countryId"
                                        name="country_id"
                                        class="c-form__input"
                                        required="required"
                                        id="country_id"
                                        aria-invalid="false"
                                    >
                                        <option
                                            v-for="(country, countryId) in availableCountries"
                                            :key="countryId"
                                            :value="countryId"
                                        >
                                            {{ country }}
                                        </option>
                                    </select>
                                </div>
                            </div>

                            <div class="l-col">
                                <TextInput
                                    ref="inputPhone"
                                    :name="`phone`"
                                    type="tel"
                                    :label="$t('Switch.Form.Phone.label')"
                                    :placeholder="$t('Switch.Form.Phone.placeholder')"
                                    inputClass="smartform-phone-number smartform-instance-phone-new-address"
                                    v-model="newAddressData.phone"
                                />
                            </div>
                        </div>

                        <div class="c-switch-form__buttons">
                            <button
                                class="c-btn c-btn--submit"
                                :class="{ 'is-loading': addressIsSubmitting }"
                                type="button"
                                @click="submitAddress"
                            >
                                <i class="fa fa-paper-plane is-on-left" aria-hidden="true"></i>
                                <span>{{ $t("Switch.Form.Save") }}</span>
                            </button>

                            <button
                                v-if="modalData?.onlyAddress"
                                type="button"
                                class="c-link c-link--back"
                                data-dismiss="modal"
                            >
                                <i class="ico ico-close" aria-hidden="hidden"></i>
                                <span class="sc-text">{{ $t("Switch.Footer.btn3") }}</span>
                            </button>

                            <button
                                v-else
                                type="button"
                                class="c-link c-link--back"
                                @click="cancelAddingNewAddress"
                            >
                                <i class="ico ico-close" aria-hidden="hidden"></i>
                                <span class="sc-text">{{ $t("Switch.Footer.btn3") }}</span>
                            </button>
                        </div>
                    </div>
                </div>

                <div
                    class="c-switch-content__section c-switch-content__section--messages"
                    v-if="hasError"
                >
                    <div
                        v-if="processErrorMessage"
                        class="c-msg c-msg--error is-flash"
                        v-html="processErrorMessage"
                    ></div>
                </div>
            </div>
        </div>

        <div class="c-switch-modal__footer" v-if="!newAddressChecked">
            <div class="c-switch-footer">
                <button
                    v-if="modalData?.onlyAddress"
                    type="button"
                    class="c-link c-link--back"
                    data-dismiss="modal"
                >
                    <i class="ico ico-close" aria-hidden="hidden"></i>
                    <span class="sc-text">{{ $t("Switch.Footer.btn3") }}</span>
                </button>

                <button
                    v-else
                    type="button"
                    class="c-link c-link--back"
                    @click="cancelAddingNewAddress"
                >
                    <i class="ico ico-chevron-left-thick" aria-hidden="hidden"></i>
                    <span class="sc-text">{{ $t("Switch.Footer.btn2") }}</span>
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import Autocomplete from "./Autocomplete.vue";
import TextInput from "./TextInput.vue";
import { initAllSmartFormPhones } from "Tools/smartform";

export default {
    components: {
        Autocomplete,
        TextInput,
    },
    created() {
        this.$store.dispatch("getAvailableCountries");
    },
    watch: {
        newAddressChecked(newVal) {
            if (newVal) {
                // Initialize SmartForm phone validation when form becomes visible
                this.$nextTick(() => {
                    initAllSmartFormPhones();
                });
            }
        },
    },
    methods: {
        cancelAddingNewAddress() {
            this.$store.commit("SET_MAIN_COMPONENT", "MainSwitch");
            this.$store.commit("SET_NEW_ADDRESS_CHECKED", false);
        },
        submitAddress() {
            // Trigger validation on all TextInput components
            const inputs = this.$refs;
            let hasErrors = false;

            Object.keys(inputs).forEach((ref) => {
                if (inputs[ref].validate && typeof inputs[ref].validate === "function") {
                    inputs[ref].validate();
                    if (inputs[ref].error) {
                        hasErrors = true;
                    }
                }
            });

            // Proceed only if there are no validation errors
            if (!hasErrors && !this.addressIsSubmitting) {
                this.$store.dispatch("submitNewAddress");
                this.$store.commit("SET_ADDRESS_IS_SUBMITTING", true);
            }
        },
    },
    computed: {
        ...mapState([
            "modalData",
            "processErrorMessage",
            "addressIsSubmitting",
            "newAddressChecked",
            "newAddressCity",
            "newAddressPostCode",
            "newAddressData",
            "availableCountries",
            "shopType",
        ]),
        ...mapGetters(["hasError"]),
        newAddressTitle() {
            return this.$t("Switch.Addresses.title3");
        },
        isInternationalAddress() {
            return Number(this.newAddressData.countryId) !== 1;
        },
    },
};
</script>
